<template>
    <v-app>
        <app-bar></app-bar>
        <v-main>
            <router-view></router-view>
        </v-main>
        <footer-section></footer-section>
    </v-app>
</template>

<script>
import AppBar from './components/AppBar'
import FooterSection from './components/FooterSection.vue'

export default {
    name: 'App',

    components: {
        'app-bar': AppBar,
        'footer-section': FooterSection
    }
}
</script>
